import { render, staticRenderFns } from "./UserDetailHeader.vue?vue&type=template&id=224a8622&scoped=true"
import script from "./UserDetailHeader.vue?vue&type=script&lang=js"
export * from "./UserDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./UserDetailHeader.vue?vue&type=style&index=0&id=224a8622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224a8622",
  null
  
)

export default component.exports